module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.departmentList.length == 0) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.statusDescription),
      callback: function($$v) {
        _vm.statusDescription = $$v
      },
      expression: "statusDescription"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.departmentList.length != 0) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.statusDescription),
      callback: function($$v) {
        _vm.statusDescription = $$v
      },
      expression: "statusDescription"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Reasons: "), _c('small', [_vm._v("( Too expensive, Timing, Not needed anymore etc\n            )")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Reasons",
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.statusReasons),
      callback: function($$v) {
        _vm.statusReasons = $$v
      },
      expression: "statusReasons"
    }
  })], 1), _vm._v(" "), (_vm.departmentList.length > 0 && _vm.fncCheckDeps()) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Department:")]), _vm._v(" "), _c('small', [_vm._v("These departments will have access to this status")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "item-value": "id",
      "item-text": "name",
      "label": "Status Department",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.statusDepartment),
      callback: function($$v) {
        _vm.statusDepartment = $$v
      },
      expression: "statusDepartment"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userRoles.length > 0 && _vm.departmentList.length != 0 && _vm.fncCheckDeps()) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Roles:")]), _vm._v(" "), _c('small', [_vm._v("These roles will be able to change a quote to this status")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.userRoles,
      "item-value": "id",
      "item-text": "name",
      "label": "Status Role",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.statusRoles),
      callback: function($$v) {
        _vm.statusRoles = $$v
      },
      expression: "statusRoles"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("PIPELINE STATUS GROUPING *")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_new_lead',
      "label": "New Leads"
    },
    model: {
      value: (_vm.new_lead),
      callback: function($$v) {
        _vm.new_lead = $$v
      },
      expression: "new_lead"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_initial_engagement_quote',
      "label": "Initial Engagement & Quoting"
    },
    model: {
      value: (_vm.initial_engagement_quoting),
      callback: function($$v) {
        _vm.initial_engagement_quoting = $$v
      },
      expression: "initial_engagement_quoting"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_negotiating_customer_approval',
      "label": "Negotiating Customer Approval"
    },
    model: {
      value: (_vm.negotiating_customer_approval),
      callback: function($$v) {
        _vm.negotiating_customer_approval = $$v
      },
      expression: "negotiating_customer_approval"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_manufacturer_fulfilment',
      "label": "Manufacturer & Fulfilment"
    },
    model: {
      value: (_vm.manufacturer_fulfilment),
      callback: function($$v) {
        _vm.manufacturer_fulfilment = $$v
      },
      expression: "manufacturer_fulfilment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_cancelled_expired_rejected',
      "label": "Cancelled, Expired or Rejected"
    },
    model: {
      value: (_vm.cancelled_expired_rejected),
      callback: function($$v) {
        _vm.cancelled_expired_rejected = $$v
      },
      expression: "cancelled_expired_rejected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("GENERAL STATUS FLAGS")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Converted"
    },
    model: {
      value: (_vm.is_converted),
      callback: function($$v) {
        _vm.is_converted = $$v
      },
      expression: "is_converted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "New Lead"
    },
    model: {
      value: (_vm.is_new_lead),
      callback: function($$v) {
        _vm.is_new_lead = $$v
      },
      expression: "is_new_lead"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Gathering Customer Requirements"
    },
    model: {
      value: (_vm.is_gathering_customer_reqs),
      callback: function($$v) {
        _vm.is_gathering_customer_reqs = $$v
      },
      expression: "is_gathering_customer_reqs"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Quote Sent - Following Up"
    },
    model: {
      value: (_vm.is_quote_sent),
      callback: function($$v) {
        _vm.is_quote_sent = $$v
      },
      expression: "is_quote_sent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Requote Requested"
    },
    model: {
      value: (_vm.is_requote_requested),
      callback: function($$v) {
        _vm.is_requote_requested = $$v
      },
      expression: "is_requote_requested"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Rejected"
    },
    model: {
      value: (_vm.is_rejected),
      callback: function($$v) {
        _vm.is_rejected = $$v
      },
      expression: "is_rejected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Awaiting Acceptance"
    },
    model: {
      value: (_vm.awaitingAcceptance),
      callback: function($$v) {
        _vm.awaitingAcceptance = $$v
      },
      expression: "awaitingAcceptance"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Requirements Sent to Design Team"
    },
    model: {
      value: (_vm.is_reqs_sent_to_design_team),
      callback: function($$v) {
        _vm.is_reqs_sent_to_design_team = $$v
      },
      expression: "is_reqs_sent_to_design_team"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Quote Completed by Design team"
    },
    model: {
      value: (_vm.is_quote_completed_by_design_team),
      callback: function($$v) {
        _vm.is_quote_completed_by_design_team = $$v
      },
      expression: "is_quote_completed_by_design_team"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Accepted Status"
    },
    model: {
      value: (_vm.acceptedStatus),
      callback: function($$v) {
        _vm.acceptedStatus = $$v
      },
      expression: "acceptedStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Cancel Status"
    },
    model: {
      value: (_vm.cancelStatus),
      callback: function($$v) {
        _vm.cancelStatus = $$v
      },
      expression: "cancelStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Expired Status"
    },
    model: {
      value: (_vm.expiredStatus),
      callback: function($$v) {
        _vm.expiredStatus = $$v
      },
      expression: "expiredStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("STATUS API TRIGGERS")])])]), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Locks Quote"
    },
    model: {
      value: (_vm.locksQuote),
      callback: function($$v) {
        _vm.locksQuote = $$v
      },
      expression: "locksQuote"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [(_vm.globalModalParams.hasCheckedOut == false) ? _c('v-switch', {
    attrs: {
      "label": "Checked Out Online"
    },
    model: {
      value: (_vm.checkedStatus),
      callback: function($$v) {
        _vm.checkedStatus = $$v
      },
      expression: "checkedStatus"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.hasCheckedOut == true) ? _c('v-switch', {
    attrs: {
      "disabled": true,
      "label": "Checked Out Online"
    },
    model: {
      value: (_vm.checkedStatus),
      callback: function($$v) {
        _vm.checkedStatus = $$v
      },
      expression: "checkedStatus"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    staticStyle: {
      "float": "left",
      "display": "block",
      "margin-top": "-22px",
      "font-size": "10px"
    }
  }, [_vm._v("Reduces Stock")])], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Order Button"
    },
    model: {
      value: (_vm.vendorStatus),
      callback: function($$v) {
        _vm.vendorStatus = $$v
      },
      expression: "vendorStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer Email Accept"
    },
    model: {
      value: (_vm.customerAccept),
      callback: function($$v) {
        _vm.customerAccept = $$v
      },
      expression: "customerAccept"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer Email Accept Final"
    },
    model: {
      value: (_vm.customerAcceptFinal),
      callback: function($$v) {
        _vm.customerAcceptFinal = $$v
      },
      expression: "customerAcceptFinal"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer Email Reject"
    },
    model: {
      value: (_vm.customerReject),
      callback: function($$v) {
        _vm.customerReject = $$v
      },
      expression: "customerReject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Request for Requote"
    },
    model: {
      value: (_vm.reorderQuote),
      callback: function($$v) {
        _vm.reorderQuote = $$v
      },
      expression: "reorderQuote"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Dispatched Status"
    },
    model: {
      value: (_vm.dispatchedStatus),
      callback: function($$v) {
        _vm.dispatchedStatus = $$v
      },
      expression: "dispatchedStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Picked Status"
    },
    model: {
      value: (_vm.pickedStatus),
      callback: function($$v) {
        _vm.pickedStatus = $$v
      },
      expression: "pickedStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Print Status"
    },
    model: {
      value: (_vm.printStatus),
      callback: function($$v) {
        _vm.printStatus = $$v
      },
      expression: "printStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Send to Hybris Trolley"
    },
    model: {
      value: (_vm.hybrisTrolleyStatus),
      callback: function($$v) {
        _vm.hybrisTrolleyStatus = $$v
      },
      expression: "hybrisTrolleyStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Send to Hybris Shopping List"
    },
    model: {
      value: (_vm.hybrisStatus),
      callback: function($$v) {
        _vm.hybrisStatus = $$v
      },
      expression: "hybrisStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Status that you cant move back from once payment has been made"
    },
    model: {
      value: (_vm.backStatus),
      callback: function($$v) {
        _vm.backStatus = $$v
      },
      expression: "backStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Status that you cant move passed before payment has been made"
    },
    model: {
      value: (_vm.forwardStatus),
      callback: function($$v) {
        _vm.forwardStatus = $$v
      },
      expression: "forwardStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Manufactured Status"
    },
    model: {
      value: (_vm.manufacturedStatus),
      callback: function($$v) {
        _vm.manufacturedStatus = $$v
      },
      expression: "manufacturedStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Delivered to Store Status"
    },
    model: {
      value: (_vm.deliveredToStoreStatus),
      callback: function($$v) {
        _vm.deliveredToStoreStatus = $$v
      },
      expression: "deliveredToStoreStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Process Order"
    },
    model: {
      value: (_vm.is_process_order),
      callback: function($$v) {
        _vm.is_process_order = $$v
      },
      expression: "is_process_order"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is Waiting For Tender"
    },
    model: {
      value: (_vm.is_waiting_tender),
      callback: function($$v) {
        _vm.is_waiting_tender = $$v
      },
      expression: "is_waiting_tender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is POD Uploaded"
    },
    model: {
      value: (_vm.is_pod_uploaded),
      callback: function($$v) {
        _vm.is_pod_uploaded = $$v
      },
      expression: "is_pod_uploaded"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Send To Customer"
    },
    model: {
      value: (_vm.is_customer_send),
      callback: function($$v) {
        _vm.is_customer_send = $$v
      },
      expression: "is_customer_send"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ignore For Reporting"
    },
    model: {
      value: (_vm.is_ignore),
      callback: function($$v) {
        _vm.is_ignore = $$v
      },
      expression: "is_ignore"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "PO Received"
    },
    model: {
      value: (_vm.poStatus),
      callback: function($$v) {
        _vm.poStatus = $$v
      },
      expression: "poStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Color:")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.styleColor),
      callback: function($$v) {
        _vm.styleColor = $$v
      },
      expression: "styleColor"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("E-COMMERCE FLAG STATUS")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Cancelled"
    },
    model: {
      value: (_vm.is_ecommerce_cancelled),
      callback: function($$v) {
        _vm.is_ecommerce_cancelled = $$v
      },
      expression: "is_ecommerce_cancelled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Pending"
    },
    model: {
      value: (_vm.is_ecommerce_pending),
      callback: function($$v) {
        _vm.is_ecommerce_pending = $$v
      },
      expression: "is_ecommerce_pending"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Successful"
    },
    model: {
      value: (_vm.is_ecommerce_success),
      callback: function($$v) {
        _vm.is_ecommerce_success = $$v
      },
      expression: "is_ecommerce_success"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Failed"
    },
    model: {
      value: (_vm.is_ecommerce_failed),
      callback: function($$v) {
        _vm.is_ecommerce_failed = $$v
      },
      expression: "is_ecommerce_failed"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is Delivered"
    },
    model: {
      value: (_vm.is_delivered),
      callback: function($$v) {
        _vm.is_delivered = $$v
      },
      expression: "is_delivered"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("4SURE STATUSES")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installation In Progress Status"
    },
    model: {
      value: (_vm.installationWipStatus),
      callback: function($$v) {
        _vm.installationWipStatus = $$v
      },
      expression: "installationWipStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installation Complete Status"
    },
    model: {
      value: (_vm.installationCompleteStatus),
      callback: function($$v) {
        _vm.installationCompleteStatus = $$v
      },
      expression: "installationCompleteStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Job Completed"
    },
    model: {
      value: (_vm.fsJobCompleted),
      callback: function($$v) {
        _vm.fsJobCompleted = $$v
      },
      expression: "fsJobCompleted"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Job Cancelled"
    },
    model: {
      value: (_vm.fsJobCancelled),
      callback: function($$v) {
        _vm.fsJobCancelled = $$v
      },
      expression: "fsJobCancelled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Awaiting Stock"
    },
    model: {
      value: (_vm.fsAwaitingStock),
      callback: function($$v) {
        _vm.fsAwaitingStock = $$v
      },
      expression: "fsAwaitingStock"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "TL On Site"
    },
    model: {
      value: (_vm.fsTlOnSite),
      callback: function($$v) {
        _vm.fsTlOnSite = $$v
      },
      expression: "fsTlOnSite"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Work Paused"
    },
    model: {
      value: (_vm.fsWordPaused),
      callback: function($$v) {
        _vm.fsWordPaused = $$v
      },
      expression: "fsWordPaused"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "No Appointment"
    },
    model: {
      value: (_vm.fsNoAppointment),
      callback: function($$v) {
        _vm.fsNoAppointment = $$v
      },
      expression: "fsNoAppointment"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ready For Delivery"
    },
    model: {
      value: (_vm.fsReadyForDelivery),
      callback: function($$v) {
        _vm.fsReadyForDelivery = $$v
      },
      expression: "fsReadyForDelivery"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer Allocated"
    },
    model: {
      value: (_vm.fsInstallerAllocated),
      callback: function($$v) {
        _vm.fsInstallerAllocated = $$v
      },
      expression: "fsInstallerAllocated"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer On Route - Stock Collect"
    },
    model: {
      value: (_vm.fsInstallerOnRouteStockCollect),
      callback: function($$v) {
        _vm.fsInstallerOnRouteStockCollect = $$v
      },
      expression: "fsInstallerOnRouteStockCollect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer At Dispatch"
    },
    model: {
      value: (_vm.fsInstallerAtDispatch),
      callback: function($$v) {
        _vm.fsInstallerAtDispatch = $$v
      },
      expression: "fsInstallerAtDispatch"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Collection Cancelled"
    },
    model: {
      value: (_vm.fsCollectionCancelled),
      callback: function($$v) {
        _vm.fsCollectionCancelled = $$v
      },
      expression: "fsCollectionCancelled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer On Route - Customer"
    },
    model: {
      value: (_vm.fsInstallerOnRouteCustomer),
      callback: function($$v) {
        _vm.fsInstallerOnRouteCustomer = $$v
      },
      expression: "fsInstallerOnRouteCustomer"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.update_vars
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddStatus()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}